import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import SignInModalHost from 'Pods/Shared/AiLanding/SignInModalHost/SignInModalHost'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import Card from './Components/Card/Card'

const EAGER_IMAGE_COUNT = 3

function AiGeneratorHub({ locale = 'en', title = '', items = EMPTY_ARRAY }) {
  return (
    <div className="ai-generator-hub">
      <div className="ai-generator-hub__container">
        <h1 className="ai-generator-hub__title cgt-heading-600">{title}</h1>
        <ul className="ai-generator-hub__grid">
          {items.map((item, index) => (
            <li key={item.href} className="ai-generator-hub__item">
              <Card
                href={item.href}
                heading={item.heading}
                imageSrc={item.imageSrc}
                eager={index < EAGER_IMAGE_COUNT}
              />
            </li>
          ))}
        </ul>
      </div>
      <SignInModalHost locale={locale} />
    </div>
  )
}

AiGeneratorHub.propTypes = {
  locale: string,
  title: string,
  items: arrayOf(shape({
    href: string.isRequired,
    heading: string.isRequired,
    imageSrc: string,
  })),
}

export default AiGeneratorHub
